const coachInfoCardTestIDs = {
  profilePicture: 'coach-profile-picture',
  coachRank: 'coach-rank',
  coachName: 'coach-name',
  rankDescription: 'rank-description',
  nextRankValue: 'next-rank-value',
  nextRankText: 'next-rank-text',
  volumeTitle: 'volume-title',
  teamsTitle: 'teams-title',

  pqv: 'pqv-value',
  fqv: 'fqv-value',
  gqv: 'gqv-value',
  gen0qv: 'gen0qv-value',
  tgenv: 'tgenv-value',
  sc: 'sc-value',
  ed: 'ed-value',
  fibc: 'fibc-value',
  fibl: 'fibl-value',

  certificationContent: 'certification-content',
  gqvContent: 'gqv-content',
  fqvContent: 'fqv-content',
  oeContent: 'oe-content',
  bonusOeContent: 'bonus-oe-content',
  daysForEligibilityContent: 'days-for-eligibility-content',
  qualifyingPointsContent: 'qualifying-points-content',
  seniorCoachTeamsContent: 'senior-coach-teams-content',
  activationDateContent: 'activation-date-content',
  businessCoachContent: 'business-coach-content',
  harContent: 'har-content',
  earnedQSBContent: 'earned-qsb-content',
  newHARContent: 'new-har-content',
  previousHARContent: 'previous-har-content',
  rankUpForContent: 'rank-up-for-content',
  earnedOnContent: 'earned-on-content',
  renewalExpiresContent: 'renewal-expires-content',
  frontlineCoachesContent: 'frontline-coaches-content',
  frontlineClientsContent: 'frontline-clients-content',
  eligibleForABTitle: 'eligible-for-accelerator-bonus-title',
  eligibleThrough: 'eligible-through',
  eligibleThroughLabel: 'eligible-through-label',
  eligibleThroughValue: 'eligible-through-value',
  eligibleForCSBPTitle: 'eligible-for-csbp-title',
  earnedABTitle: 'earned-coach-accelerator-bonus-title',
};

export default coachInfoCardTestIDs;
